import { render, staticRenderFns } from "./Prescriptionlist.vue?vue&type=template&id=1b69b336&scoped=true&"
import script from "./Prescriptionlist.vue?vue&type=script&lang=js&"
export * from "./Prescriptionlist.vue?vue&type=script&lang=js&"
import style0 from "./Prescriptionlist.vue?vue&type=style&index=0&id=1b69b336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b69b336",
  null
  
)

export default component.exports